export default "__VITE_ASSET__ZDaYSa1o__"